import { Amplify } from "aws-amplify";
import { Outlet } from "react-router-dom";
import { useAuthContext } from '../contexts/AuthContext';
import Client from '../appolo/Client';
// import useNavBarItems from './services/NavBarItems';
import RenderNavBar from './services/NavBarItems';
// import config from  '../graphql/amplify_outputs.json';
import configDev from '../graphql/amplify_outputs_dev_sandbox.json';
import configProd from '../graphql/amplify_outputs_prod.json';
// @ts-ignore: CSS side-effect import has no type declarations
import '../App.css';
import { BsFacebook, BsInstagram, BsTwitterX } from 'react-icons/bs';
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import AIChatBox from './services/AIChatBox';
import { Container, Spinner, Navbar, Nav, Button } from "react-bootstrap";
import Cookies from "js-cookie";
import i18n from "../contexts/I18n";
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';


const env = process.env.REACT_APP_ENV;

Amplify.configure(env === "prod" ? configProd : configDev);

const Layout = ({ direction, ...args }: { direction: string; [key: string]: any }) => {
  const { t } = useTranslation();
  const {user, userId} = useAuthContext();
  const location = useLocation();
  const [client , setClient] = useState(null)
  // const { renderNavBar } = useNavBarItems();
  const [isUserLoaded, setIsUserLoaded] = useState(false);
  // const [isLoading, setIsLoading] = useState(true);
  // AI CHATBOX
  const [isAIChatOpen, setIsAIChatOpen] = useState<boolean>(() => {
    const savedOpenState = localStorage.getItem('ai_chat_open');
    // Si c'est égal à 'true', la boîte s'ouvrira automatiquement au chargement de la page
    return savedOpenState === 'true'; 
  });
  const isPublicShiftPage = location.pathname === '/planificateur/quarts_publics' || location.pathname === '/scheduler/open_shifts';
  const isMessagePage = location.pathname === '/messages' || location.pathname === '/posts' || location.pathname.startsWith('/posts/');
  
  // scroll top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (user && !isUserLoaded) {
      getUser();
    }
  }, [user, isUserLoaded]);

  const getUser = async () => {
    // setIsLoading(true);
    try {
      setIsUserLoaded(true);
      const response = await axios.get("/api/graphql/user/" + userId);
      setClient(response.data);
      // setIsUserLoaded(true);
      // setIsLoading(false);
    } catch (error) {
      console.error("Erreur de chargement de l'utilisateur :", error.message);
      // setIsLoading(false);
    }
  }

  // if (isLoading) {
  //   return (
  //     <div className="loading-container">
  //       <Spinner animation="border" variant="primary" />
  //       {/* <p>Chargement...</p> */}
  //     </div>
  //   );
  // }

  return (
    <>
      {/* {renderNavBar(user, client)} */}
      <RenderNavBar
        user={user}
        client={client}
      />
      {/* user && user.userId ?? (
        <RenderNavBar
          user={user}
          client={client}
        />
      ) */}
      <Container fluid className="layoutWrapper">
        <Outlet />
      </Container>
      { !(window.location.pathname == t('link.scheduler') || window.location.pathname == "/scheduler/mobile") &&
        <footer id="footer" data-bs-theme="dark" className="bg-body-tertiary">
          <ul className="nav float-end col-md-4 justify-content-end list-unstyled d-flex">
            <li className="ms-3">
              <a className="text-body-secondary" href="https://x.com/schedulum" target="_blank" rel="noopener noreferrer">
                <BsTwitterX size={32} />
              </a>
            </li>
            <li className="ms-3">
              <a className="text-body-secondary" href="https://www.instagram.com/schedulum" target="_blank" rel="noopener noreferrer">
                <BsInstagram size={32} />
              </a>
            </li>
            <li className="ms-3">
              <a className="text-body-secondary" href="https://www.facebook.com/people/Schedulum-App/pfbid02qLHFPCwgDcDX6tZcJdWp5MV3XgsMEr64kpdSzzh2Z3WP4gZcJdqaFcC8nEjTQJdtl" target="_blank" rel="noopener noreferrer">
                <BsFacebook size={32} />
              </a>
            </li>
          </ul>

          <p className="justify-content-start">© 2026 Schedulum</p>
          {/* COMPOSANT DE CHAT : Flotte par-dessus sans bloquer le reste */}
          {isPublicShiftPage ?
          <div style={{ zIndex: 1100, position: 'fixed' }}>
              <AIChatBox
              isOpen={isAIChatOpen} 
              onClose={() => setIsAIChatOpen(false)} 
              language={i18n.language}// Position fixe pour flotter au-dessus
            />
            </div>
          :
            <AIChatBox
              isOpen={isAIChatOpen} 
              onClose={() => setIsAIChatOpen(false)} 
              language={i18n.language}
            />
          }

          {/* BOUTON BULLE : Permet d'ouvrir / fermer la boîte au clic */}
          <button 
            onClick={() => setIsAIChatOpen(!isAIChatOpen)} // Alterne entre ouvert et fermé
            className="btn btn-primary rounded-circle border border-white border-5 aiChatButton"
            style={isPublicShiftPage ? { bottom: '23px', right: '130px' } : isMessagePage ? { bottom: '60px', right: '130px' } : {}} // Ajuste la position si on est sur la page des quarts publics
          >
            {/* <i className="bi bi-chat-dots-fill">✨</i>             */}
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
              <path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M3 8.062C3 6.72 4.249 5.5 6 5.5h4c1.751 0 3 1.22 3 2.562v1.248c0 1.342-1.249 2.562-3 2.562H6c-1.751 0-3-1.22-3-2.562zm1.998-.439v1.626c0 .733.479 1.313 1.17 1.313h3.664c.69 0 1.17-.58 1.17-1.313V7.623c0-.733-.48-1.313-1.17-1.313H6.168c-.69 0-1.17.58-1.17 1.313"/>
              <path d="M11 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM2 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM13 3.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zm-11 0a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5z"/>
              <path d="M8 1a2.5 2.5 0 0 0-2.5 2.5V4h5v-.5A2.5 2.5 0 0 0 8 1m1.5 3h-3v-.5a1.5 1.5 0 0 1 3 0z"/>
            </svg> */}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
              <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
              <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
            </svg>
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
              <path d="M2.5 7.5A.5.5 0 0 1 3 8v1.5H4.5a.5.5 0 0 1 0 1H3V12a.5.5 0 0 1-1 0v-1.5H.5a.5.5 0 0 1 0-1H2V8a.5.5 0 0 1 .5-.5m10 0a.5.5 0 0 1 .5.5v1.5h1.5a.5.5 0 0 1 0 1H14V12a.5.5 0 0 1-1 0v-1.5h-1.5a.5.5 0 0 1 0-1H13V8a.5.5 0 0 1 .5-.5M7.5.5A.5.5 0 0 1 8 1v3.5H11.5a.5.5 0 0 1 0 1H8V9a.5.5 0 0 1-1 0V5.5H3.5a.5.5 0 0 1 0-1H7V1a.5.5 0 0 1 .5-.5"/>
            </svg> */}
            {/* 🗣️ */}
            {/* 🤖 */}
            {/* 🧠 */}
            {/* 🔮 */}
            {/* ✨ */}
            {/* 💬 */}
          </button>
        </footer>
      }
    </>
  )
};

export default Layout;